import { FC } from 'react';

import { ButtonType, buttonTypes } from './config';

interface IProps {
  variant: 'pause' | 'primary' | 'outline' | 'team-picker' | 'chooser';
}

const Button: FC<IProps & ButtonType> = ({ variant, ...props }) => buttonTypes(props)[variant];

export default Button;
